// 使用 emoji 国旗映射 - 兼容所有现代浏览器
// 如果需要更精确的国旗图片，可以使用 CDN 服务如 flagcdn.com

export const languageFlags = {
  en: {
    emoji: '🇬🇧',
    // 或者使用图片 URL:
    // image: 'https://flagcdn.com/w40/gb.png',
    name: 'English'
  },
  fr: {
    emoji: '🇫🇷',
    // image: 'https://flagcdn.com/w40/fr.png',
    name: 'Français'
  },
  pt: {
    emoji: '🇵',
    // image: 'https://flagcdn.com/w40/pt.png',
    name: 'Português'
  },
  es: {
    emoji: '🇪🇸',
    // image: 'https://flagcdn.com/w40/es.png',
    name: 'Español'
  },
  zh: {
    emoji: '🇨🇳',
    // image: 'https://flagcdn.com/w40/cn.png',
    name: '简体中文'
  },
  'zh-HK': {
    emoji: '🇭🇰',
    // image: 'https://flagcdn.com/w40/hk.png',
    name: '繁體中文'
  },
  mn: {
    emoji: '🇲🇳',
    // image: 'https://flagcdn.com/w40/mn.png',
    name: 'Монгол'
  },
  ko: {
    emoji: '🇰🇷',
    // image: 'https://flagcdn.com/w40/kr.png',
    name: '한국어'
  },
  ja: {
    emoji: '🇯🇵',
    // image: 'https://flagcdn.com/w40/jp.png',
    name: '日本語'
  },
  vi: {
    emoji: '🇻🇳',
    // image: 'https://flagcdn.com/w40/vn.png',
    name: 'Tiếng Việt'
  }
}

// 获取国旗图片 URL（使用 flagcdn.com CDN）
export const getFlagImageUrl = (countryCode) => {
  const countryMap = {
    en: 'gb',
    fr: 'fr',
    pt: 'pt',
    es: 'es',
    zh: 'cn',
    'zh-HK': 'hk',
    mn: 'mn',
    ko: 'kr',
    ja: 'jp',
    vi: 'vn'
  }
  const code = countryMap[countryCode] || countryCode
  return `https://flagcdn.com/w40/${code}.png`
}

// 国旗图片组件
export function FlagIcon({ code, size = 24, className = '' }) {
  const url = getFlagImageUrl(code)

  return (
    <img
      src={url}
      alt={`${code} flag`}
      className={className}
      style={{
        width: size,
        height: size,
        objectFit: 'cover',
        borderRadius: size > 20 ? '2px' : '1px',
        display: 'block'
      }}
    />
  )
}
